import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../../services/indentifyDevice";
import "../../../assets/scss/Login/login/loginScreen/loginScreen.scss";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";
import EtotpForm, { ITotpFormProps } from "../forms/etotpPasswordForm";

export interface IEtotpScreenProps extends ITotpFormProps {
  onClose?: () => void;
}

const EtotpScreen: React.FC<IEtotpScreenProps> = (props) => {
  return (
    <LoginPopup
      leftHeaderContent={
        !DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      centerHeaderContent={
        DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      onClose={props.onClose}
      className="login_scrn"
    >
      <EtotpForm {...props} /> 
    </LoginPopup>
  );
};

export default EtotpScreen;
